function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_10802",
  "data-name": "\\uADF8\\uB8F9 10802",
  transform: "translate(-1668.094 -124.991)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_7493",
  "data-name": "\\uD328\\uC2A4 7493",
  d: "M1692.566,126.637a18.084,18.084,0,0,0-17.632,29.119l-5.59,9.193,9.077-5.9a18.083,18.083,0,1,0,14.145-32.407Z",
  fill: "none",
  stroke: "#8e8e8e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_10801",
  "data-name": "\\uADF8\\uB8F9 10801",
  transform: "translate(1680.769 143.512)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "\\uD0C0\\uC6D0_273",
  "data-name": "\\uD0C0\\uC6D0 273",
  cx: 1.751,
  cy: 1.751,
  r: 1.751,
  fill: "#8e8e8e"
}), /*#__PURE__*/React.createElement("circle", {
  id: "\\uD0C0\\uC6D0_274",
  "data-name": "\\uD0C0\\uC6D0 274",
  cx: 1.751,
  cy: 1.751,
  r: 1.751,
  transform: "translate(6.838)",
  fill: "#8e8e8e"
}), /*#__PURE__*/React.createElement("circle", {
  id: "\\uD0C0\\uC6D0_275",
  "data-name": "\\uD0C0\\uC6D0 275",
  cx: 1.751,
  cy: 1.751,
  r: 1.751,
  transform: "translate(13.676)",
  fill: "#8e8e8e"
})));

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.249,
    height: 41.207,
    viewBox: "0 0 40.249 41.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.2b0fb360.svg";
export { ForwardRef as ReactComponent };